// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__35giM","inputWrap":"styles_inputWrap__15NWw","input":"styles_input__2y9Vp"};